import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CanAcessPipe } from './can-access.pipe';

@NgModule({
  declarations: [CanAcessPipe],
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [CanAcessPipe],
})
export class CanAccessModule {}
